import { ApiError, QueryKeys, SmartAction } from '@connect-x-app/shared-domain-models';
import { getSmartAction } from '@connect-x-app/web-data-access';
import { useQuery } from '@tanstack/react-query';

export const useSmartAction = (smartActionId: string) =>
  useQuery<SmartAction, ApiError>({
    queryFn: () => getSmartAction(smartActionId),
    queryKey: [QueryKeys.SMART_ACTION, smartActionId],
  });
